export default __webpack_public_path__ + "static/media/crown_gold.f51e6645.svg";